import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
export default class Loading extends Component {
    render() {
        return React.createElement(Spinner, Object.assign({}, this.props));
    }
}
const SpinnerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    // display: 'inline-block',
    width: '30px',
    height: '30px',
    marginTop: '-15px',
    marginLeft: '-15px',
    borderRadius: '50%',
    border: `2px solid ${Theme.color.hairline}`,
    borderTopColor: Theme.color.primary,
    animation: `spinner .7s ease-in-out infinite`
    // backgroundColor: 'white',
    // boxShadow: '0 0 10px white'
};
const Spinner = cxs('div')(SpinnerStyle);
export const spinner = {
    ':before': Object.assign(Object.assign({}, SpinnerStyle), { content: '""' })
};
export const loading = (promises) => (DecoratedComponent) => class extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            values: undefined
        };
    }
    componentWillMount() {
        Promise.all(promises(this.props)).then(results => {
            this.setState({
                values: results.reduce((values, value) => {
                    if (typeof value === 'object')
                        Object.assign(values, value);
                    return values;
                }, {})
            });
        });
    }
    render() {
        const { values } = this.state;
        if (values)
            return React.createElement(DecoratedComponent, Object.assign({}, this.props, values));
        return React.createElement(Loading, null);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Loading.tsx
// module id = 31
// module chunks = 0